export const API_BASE = '/api';
export const COOWN_ADMIN_BUILD = "2026-05-22-admin-rent-manage-v1";
export const ADMIN_REVIEW_LOG_PREVIEW = 3;
export const SUBMISSION_PUBLISH_STATUSES = ["live"];
export const COOWN_SUPPORT_EMAIL = "support@joincoown.com";
export const CHAT_REPORT_RESOLUTION_PRESETS = [
  {
    value: "no_violation",
    label: "No policy violation found",
    text: "After review, we did not find a violation of CoOwn platform policies.",
    blockUser: false,
  },
  {
    value: "warning_issued",
    label: "Warning issued",
    text: "A formal warning was issued to the reported user regarding their conduct.",
    blockUser: false,
  },
  {
    value: "account_blocked",
    label: "Account blocked for policy violation",
    text: "The reported account was blocked for violating CoOwn platform policies.",
    blockUser: true,
  },
  {
    value: "insufficient_evidence",
    label: "Insufficient evidence",
    text: "We could not verify the report with the information available.",
    blockUser: false,
  },
  {
    value: "duplicate_report",
    label: "Duplicate or invalid report",
    text: "This report was duplicate, invalid, or outside platform scope.",
    blockUser: false,
  },
  {
    value: "other",
    label: "Other (write your own conclusion)",
    text: "",
    blockUser: false,
  },
];
export const MAX_LISTING_IMAGES = 30;
export const LISTINGS_PAGE_SIZE = 12;
export const PORTFOLIO_INVESTMENTS_PAGE_SIZE = 10;
export const ADMIN_LIVE_LISTINGS_PAGE_SIZE = 15;
export const ADMIN_DELETED_LISTINGS_PAGE_SIZE = 15;
export const COOWN_PROJECT_START_YEAR = 2026;
/** How many years ahead of today admin date filters allow (month/day calendar pickers). */
export const COOWN_DATE_FILTER_YEAR_HORIZON = 10;
export const COMPARE_MAX = 3;
export const PLATFORM_ACQUISITION_FEE_RATE = 0.05;
export const PLATFORM_ANNUAL_MGMT_FEE_RATE = 0.01;
export const PLATFORM_MARKETPLACE_FEE_PER_SIDE = 0.01;
export const BROWSE_CATEGORY_OPTIONS = ["Any Category", "Residential", "Commercial", "Vacation", "Land"];
export const BROWSE_DEFAULT_PRICE_MIN = "1";
export const BROWSE_DEFAULT_PRICE_MAX = "";
export const MARKETPLACE_IMAGE_FALLBACK = "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800";

export const PROPERTY_OFFERING_DISCLAIMER =
  "The Information and Documents were provided to us by the owner or property management company. CoOwn assumes no liability for their accuracy or completeness";

export const PLATFORM_PRODUCT_STATS = [
  { value: "From $500", label: "Typical min. investment" },
  { value: "Tokenized", label: "On-chain share records" },
  { value: "USDC / ALGO", label: "Crypto checkout option" },
  { value: "Reviewed", label: "Admin-verified listings" },
];

export const HERO_LANDING_STATS = [
  { label: "From $500", sub: "Minimum Investment" },
  { label: "Tokenized", sub: "Digital Ownership" },
  { label: "USDC / ALGO", sub: "Crypto Checkout" },
  { label: "Reviewed", sub: "Verified Listings" },
];

export const PIPELINE_STEPS = [
  { key: "listed", label: "Listed", icon: "fa-file-alt" },
  { key: "meeting", label: "Meeting", icon: "fa-handshake" },
  { key: "inspection", label: "Inspection", icon: "fa-search" },
  { key: "price_agreement", label: "Price Agreement", icon: "fa-file-signature" },
  { key: "approved", label: "Approved", icon: "fa-check" },
  { key: "live", label: "Live on Site", icon: "fa-globe" }
];

export const SEC_OFFERING_TYPE_LABELS = {
  Reg_CF: "Reg CF",
  Reg_A: "Reg A",
  Reg_D: "Reg D",
  Private: "Private placement"
};

export const FEATURED_MARKET_CODES = ["US", "UK", "GB", "DE", "FR", "IT", "NG", "ZA", "NL", "CH"];

export const COUNTRY_FILTER_ALL = "ALL";
export const COUNTRY_FILTER_FEATURED = "FEATURED";

export const RENT_MONTHLY_COST_PRESETS = [
  { id: "electricity", label: "Electricity" },
  { id: "internet", label: "Internet" },
  { id: "insurance", label: "Insurance" },
  { id: "water", label: "Water" },
  { id: "hoa", label: "HOA / service charge" },
  { id: "other", label: "Other" }
];

export const KYC_IDENTITY_BY_COUNTRY = {
  US: { taxIdLabel: "SSN (last 4 digits)", taxIdPlaceholder: "1234", taxIdMax: 4, taxIdRequired: true, addressLine2Label: "City, State, ZIP" },
  NG: { taxIdLabel: "NIN (last 4 digits)", taxIdPlaceholder: "1234", taxIdMax: 4, taxIdRequired: true, addressLine2Label: "City, State, Postal code" },
  GB: { taxIdLabel: "National Insurance (last 4, if applicable)", taxIdPlaceholder: "Optional", taxIdMax: 4, taxIdRequired: false, addressLine2Label: "City, County, Postcode" },
  CA: { taxIdLabel: "SIN (last 4 digits)", taxIdPlaceholder: "1234", taxIdMax: 4, taxIdRequired: true, addressLine2Label: "City, Province, Postal code" },
  AU: { taxIdLabel: "TFN (last 4, if applicable)", taxIdPlaceholder: "Optional", taxIdMax: 4, taxIdRequired: false, addressLine2Label: "City, State, Postcode" },
  DEFAULT: { taxIdLabel: "National ID (last 4 digits)", taxIdPlaceholder: "1234", taxIdMax: 4, taxIdRequired: true, addressLine2Label: "City, Region, Postal code" }
};

export const RENT_EXTRA_COST_COLORS = ["#2a9d8f", "#e9c46a", "#e76f51", "#457b9d", "#f4a261", "#9b5de5", "#06d6a0", "#ef476f"];

export const HOME_STORY_BG = "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1600&q=80";
export const HOME_WHY_COOWN_IMG = "https://images.unsplash.com/photo-1600585154526-990dced4db0d?w=600&h=750&fit=crop";
